import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { ImageOff, MessageSquareOff, FolderSearch, Clock } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <ImageOff className="w-6 h-6 text-gold" data-id="element-109" />,
    text: "Guests take photos you'll never receive"
  }, {
    icon: <MessageSquareOff className="w-6 h-6 text-gold" data-id="element-110" />,
    text: 'Memories get lost across texts and social media'
  }, {
    icon: <FolderSearch className="w-6 h-6 text-gold" data-id="element-111" />,
    text: 'No simple way to collect everything'
  }, {
    icon: <Clock className="w-6 h-6 text-gold" data-id="element-112" />,
    text: "After the event… it's all gone"
  }];
  return <section className="py-24 px-6 bg-dark-lighter relative" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <FadeIn className="text-center mb-16" data-id="element-115">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-116">
            You're Missing <span className="text-gold" data-id="element-117">90%</span> of Your Event
            Memories
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-6 mb-16" data-id="element-118">
          {problems.map((problem, index) => <FadeIn key={index} delay={0.1 * index} className="bg-dark p-6 rounded-xl border border-gold/10 flex items-start gap-4" data-id="element-119">
              <div className="p-3 bg-gold/5 rounded-lg shrink-0" data-id="element-120">
                {problem.icon}
              </div>
              <p className="text-cream-dark/90 text-lg pt-1" data-id="element-121">{problem.text}</p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} className="text-center" data-id="element-122">
          <p className="font-heading text-2xl md:text-3xl text-gold italic" data-id="element-123">
            Your special day deserves more than scattered memories.
          </p>
        </FadeIn>
      </div>
    </section>;
}